<template>
	<div style="background: #F9FAFC">
		<div class="white_bg">
			<div style="display: flex; align-items: flex-end; justify-content: space-around; min-width: 600px;"
				class="margin_bottom_css">
				<span style="font-size: 22px;" v-if="nameShow">{{client.name}}</span>
				<Input v-model="client.name" v-if="!nameShow" @on-change="saveClient" style="width: 60px" />
				<span class="icon iconfont icon-bianji1" style="font-size: 25px;font-weight: bold;"
					@click="nameShow = !nameShow"></span>
				<!--div style="background-color: #BEBEBE; width: 130px; color: #FFFFFF; border-radius: 10px; display: flex;align-items: center;justify-content: center;">
                    <span class="icon iconfont icon-bianji1 img_font"></span> 生成邀约名片
                </div-->
				<!--Dropdown style="margin-left: 20px" @on-click="changeMenu">
					<Button type="primary">
						生成邀约名片
						<Icon type="ios-arrow-down"></Icon>
					</Button>
					<DropdownMenu slot="list">
						<DropdownItem name="invate_door">邀约上门</DropdownItem>
						<DropdownItem name="invate_introduce">拓客邀约</DropdownItem>
					</DropdownMenu>
				</Dropdown-->
				<div style="background-color: #E5A23C; width: 130px; color: #FFFFFF; border-radius: 10px; display: flex;align-items: center;justify-content: center;"
					@click="addPool">
					<span class="icon iconfont icon-bianji1 img_font"></span>放入公共池
				</div>
				<div style="background-color: #20A5FF; width: 100px; color: #FFFFFF; border-radius: 10px; display: flex;align-items: center;justify-content: center;"
					@click="lock">
					<div v-if="client.is_lock == -1"><span class="icon iconfont icon-duomeitiicon- img_font"></span>客户锁定
					</div>
					<div style="padding: 5px 0; padding-right: 8px" v-else><span
							class="icon iconfont icon-jiesuo img_font jiesuo_img_font"></span>客户解锁</div>
				</div>
				<div class="icon iconfont icon-dianhua"
					style="font-size: 16px; background-color: #67C239; color: #FFFFFF; width: 100px; border-radius: 10px; text-align: center" @click="callMobile">
					呼叫</div>
			</div>
			<div class="margin_bottom_css"
				style="display: flex; justify-content: space-around;min-width: 500px; align-items: center;">
				<div>
					<span v-if="client.sex == 1 " class="icon iconfont icon-nan"></span>
					<span v-if="client.sex == 2 " class="icon iconfont icon-nv"></span>
					{{client.sex_name}}
				</div>
				<div>
					<span class="icon iconfont icon-j_czxx_icon_birthday"></span>
					{{client.age}}
				</div>
				<div style="width: 120px;">
					<span class="icon iconfont icon-dianhua"></span>
					<span v-if="phoneShow">{{client.phone}}</span>
					<span v-if="!phoneShow">{{client.new_phone}}</span>
					<span class="icon iconfont icon-kejian" style="color: #259FF0; cursor: pointer;"
						@click="clickPhoneShow"></span>
				</div>
				<div>上次通话：{{client.last_call_at}}</div>
			</div>
			<div style="display: flex; justify-content: space-around; margin-left: -30px;">
				<div>来源：{{client.came_from}}</div>
				<div>申请时间：{{client.applied_at}}</div>
				<div>申请金额：{{client.loans_money/10000}}万</div>
			</div>
		</div>
		<div class="white_bg" style="margin-top: 10px">
			<Row>
				<Col span="8">
				状态：
				<Select @on-change="saveClientStatus" v-model="client.status" style="width:120px">
					<Option v-for="item in stateList" :value="item.value" :key="item.value">{{ item.label }}
					</Option>
				</Select>
				</Col>
				<Col span="8">
				<div class="flex_align" style=" width: 160px;">
					<Tooltip placement="top">
						<div slot="content">
							<div>0星：客户情况未知</div>
							<div>1星：无资质</div>
							<div>2星：资质暂时不满足</div>
							<div>2+星：有进件条件</div>
							<div>3星：有银行进件条件</div>
							<div>4星：优质条件客户</div>
						</div>
						<span class="icon iconfont icon-star" style="color: #FEC97C; cursor: pointer;"></span>
					</Tooltip>
					<div class="flex_align">
						<span style=" width: 50px;">星级：</span>
						<Select @on-change="saveClient" v-model="client.start" style="width:120px">
							<Option v-for="item in rateList" :value="item.value" :key="item.value">{{ item.label }}
							</Option>
						</Select>
					</div>
				</div>
				</Col>
				<Col span="8">
				<div class="before_next_area">
					<Button type="primary" @click="beforeOne">上一条</Button>
					<Button type="primary" @click="nextOne">下一条</Button>
				</div>
				</Col>
			</Row>
		</div>
		<div class="white_bg" style="margin-top: 10px">
			<div class="add_record_header">跟进记录</div>
			<div class="flex_align">
				<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
					<Poptip placement="bottom" width="400" v-model="tagPoptip">
						<div
							style="cursor: pointer; width: 100px; background-color: #21A0FF; color: #FFFFFF; text-align: center; border-radius: 5px; height: 30px; line-height: 30px;">
							添加资质标签
						</div>
						<div class="tabs_css" slot="content">
							<div v-for="(item,index) in tabsList" :key='index'
								:class="{ddd_css:item == '潜在需求', eee_css:item == '否认申请', fff_css:item == '异地申请', ggg_css:item == '不需要',
									 hhh_css:item == '有逾期', iii_css:item == '捣乱申请', jjj_css:item == '同行',aaa_css:item == '无条件',bbb_css:item == '查询超',ccc_css:item == '白户',black_css:item == '黑户'}"
								style="margin: 5px; cursor: pointer; width: 100px;  text-align: center; border-radius: 5px; height: 30px; line-height: 30px;"
								@click="addClientTag" :data-key="index">
								{{item}}
							</div>
						</div>
					</Poptip>
					<!--                <div>-->
					<!--                    状态：-->
					<!--                    <Select @on-change="saveClient" v-model="client.status" style="width:80px">-->
					<!--                        <Option v-for="item in stateList" :value="item.value" :key="item.value">{{ item.label }}-->
					<!--                        </Option>-->
					<!--                    </Select>-->
					<!--                </div>-->
					<div class="flex_align" style="width: 280px">
						<div>需求紧急程度：</div>
						<div class="flex_align" style="width: 180px">
							<span data-val="1" @click="addEmergency" class="emergency green_css">不紧急</span>
							<span data-val="2" @click="addEmergency" class="emergency blue_css">近期要</span>
							<span data-val="3" @click="addEmergency" class="emergency red_css">急用钱</span>
						</div>
					</div>
				</div>
			</div>
			<div style="display: flex;margin: 10px 0;">
				<Input v-model="remarkValue" type="textarea" :rows="2" />
				<div style="cursor: pointer; color: #FFFFFF; background-color: #21A0FF; width: 80px; display: flex; justify-content: center;align-items: center; border-radius: 5px;"
					@click="addRemark">
					保存备注
				</div>
			</div>
			<div style="display: flex;  justify-content: space-between;align-items: center;" class="cur_btn">
				<span>通话标签：</span>
				<div @click="addContactTag"
					style="width: 60px; text-align: center; border-radius: 5px; cursor: pointer;" :class="{black_css:item == '关机', violet_css:item == '停机', green_css:item == '不接', yellow_css:item == '需回拨', grey_css:item == '空号',
			orange_css:item == '忙线中', red_css:item == '挂断', blue_css:item == '开口挂', }" v-for="(item,index) in quickList"
					:key="index" :data-key="index">{{item}}
				</div>

			</div>
		</div>
		<div class="white_bg" style="margin-top: 10px">
			<div class="flex_align" style="width: 560px; margin-bottom: 10px">
				<div class="flex_align" style="width: 320px">
					<span style="width: 100px">下次跟进时间：</span>
					<DatePicker type="date" :value="follow.follow_time_date"
						@on-change="(e) => {follow.follow_time_date = e}" style="width: 112px"></DatePicker>
					<TimePicker type="time" v-model="follow.follow_time_hour" style="width: 95px"></TimePicker>
				</div>
				<Select v-model="followUpTime" style="width:100px" @on-change="changeFollowUpTime">
					<Option v-for="item in followUpTimeList" :value="item.value" :key="item.value">{{ item.label }}
					</Option>
				</Select>
				<div @click="saveFollow" class="plus_add" data-type="1">
					+
				</div>
			</div>
			<div class="flex_align" style="width: 560px">
				<div class="flex_align" style="width: 320px">
					<span style="width: 100px">预约上门时间：</span>
					<DatePicker type="date" :value="follow.door_time_date"
						@on-change="(e) => {follow.door_time_date = e}" style="width: 112px"></DatePicker>
					<TimePicker type="time" v-model="follow.door_time_hour" style="width: 95px"></TimePicker>
				</div>
				<Select v-model="viewUpTime" style="width:100px" @on-change="changeViewUpTime">
					<Option v-for="item in viewUpTimeList" :value="item.value" :key="item.value">{{ item.label }}
					</Option>
				</Select>
				<div @click="saveFollow" class="plus_add" data-type="2">
					+
				</div>
			</div>
			<div v-for="(item, index) in followList" :key="index" style="margin-top: 5px;">
				<span class="icon iconfont icon-biaoji_" style="font-size: 10px; margin-right:10px;"></span>
				<span class="follow_text">{{item.plan_at}}</span>
				<span class="follow_text">{{item.follow_type}}:{{item.name}}</span>
				<span class="follow_text" style="color: #E84E66;">{{item.time_left}}</span>
				<span class="follow_text" style="color: #54A1F3;width: 90px" :data-id="item.id"
					@click="eraseFollow">撤销</span>
			</div>
		</div>
		<!-- 添加签约合同对话框 -->
		<Modal v-model="addContractShow" width="900">
			<AddContract ref="addContract" @reloadData="loadData" :clientId="id"></AddContract>
			<div slot="footer">
				<Button type="primary" @click="$refs['addContract'].save()">确定</Button>
			</div>
		</Modal>

		<Modal v-model="invateDoorModal" width="45%" title="">
			<div class="flex flex_between" style="padding: 5px 30px">
				<label style="width: 100px;">客户姓名</label>
				<Input v-model="invateDoor.invate_name" placeholder="请输入姓名" />
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label style="width: 100px;">审批额度</label>
				<Input v-model="invateDoor.invate_money" placeholder="请输入预审额度" />
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label style="width: 100px;">面签日期</label>
				<DatePicker v-model="invateDoor.invate_day" type="date" placeholder="选择面签日期" @on-change="invateDayChange"  style="width: 100%">
				</DatePicker>
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label style="width: 100px;">面签地址</label>
				<Input v-model="invateDoor.invate_address" placeholder="面签地址" />
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label style="width: 100px;">面签材料</label>
				<Input v-model="invateDoor.invate_data" placeholder="面签材料" />
			</div>
			<div slot="footer">
				<Button type="text" @click="invateDoorModal=false">取消</Button>
				<Button type="primary" @click="saveInvateDoor">确定</Button>
			</div>
		</Modal>
	</div>
</template>
<script>
	import {
		mapActions,
		mapGetters
	} from "vuex";
	import config from '@/config'
	import {
		getClientRecord,
		saveClient,
		addClientTag,
		addRemark,
		addContactTag,
		saveFollow,
		lock,
		addPool,
		eraseFollow,
		addEmergencyTag,
		lookPhone,
		sendOrderNotice
	} from '@/api/client'
	import {
		getTimeLater
	} from '@/api/tools'
	import AddContract from '../task/AddContract.vue'
	export default {
		name: "AddRecord",
		props: ['id'],
		components: {
			AddContract
		},
		created() {
			this.loadData();
		},
		watch: {
			id() {
				this.loadData();
			}
		},
		computed: {
			...mapGetters(['userInfo', 'token']),
		},
		data() {
			return {
				viewUpTime: 0,
				addContractShow: false,
				invateDoorModal: false,
				viewUpTimeList: [{
						value: 0,
						label: '快捷选择'
					},
					{
						value: 7,
						label: '1天后'
					},
					{
						value: 8,
						label: '2天后'
					},
					{
						value: 9,
						label: '3天后'
					},
					{
						value: 10,
						label: '4天后'
					},
					{
						value: 11,
						label: '5天后'
					},
					{
						value: 12,
						label: '6天后'
					},
					{
						value: 13,
						label: '7天后'
					},
				],
				followUpTime: 0,
				followUpTimeList: [{
						value: 0,
						label: '快捷选择'
					},
					{
						value: 1,
						label: '10分钟后'
					},
					{
						value: 2,
						label: '30分钟后'
					},
					{
						value: 3,
						label: '1小时后'
					},
					{
						value: 4,
						label: '2小时后'
					},
					{
						value: 5,
						label: '3小时后'
					},
					{
						value: 6,
						label: '5小时后'
					},
					{
						value: 7,
						label: '1天后'
					},
					{
						value: 8,
						label: '2天后'
					},
				],
				tagPoptip: false,
				invateDoor: {
					invate_name: '',
					invate_money: '',
					invate_day: '',
					invate_address: '',
					invate_data: '',
				},
				client: {
					name: '',
					sex: '',
					sex_name: '',
					phone: '',
					new_phone: '',
					follow_name: '',
					applied_at: '',
					last_call_at: '',
					status_name: '',
					start_name: '',
					came_from: '',
					ext_info: {
						age: ''
					},
				},
				tabsList: ['潜在需求', '否认申请', '异地申请', '不需要', '有逾期', '捣乱申请', '同行', '无条件', '查询超', '白户', '黑户'],
				quickList: ['开口挂', '关机', '停机', '需回拨', '不接', '空号', '忙线中', '挂断'],
				tab_list: [{
						show: true,
						name: '开口挂'
					},
					{
						show: true,
						name: '关机'
					},
					{
						show: true,
						name: '不接'
					}
				],
				phoneShow: false,
				nameShow: true,
				remarkValue: '',
				follow: {
					door_time_date: '',
					door_time_hour: '',
					follow_time_date: '',
					follow_time_hour: '',
					remark: '',
				},
				stateList: [{
						value: 1,
						label: '未处理'
					},
					{
						value: 2,
						label: '待跟进'
					},
					{
						value: 3,
						label: '邀约中'
					},
					{
						value: 6,
						label: '上门未签约'
					},
					{
						value: 7,
						label: '已签约'
					},
					{
						value: 14,
						label: '资质不符'
					},
					{
						value: 15,
						label: '捣乱申请'
					},
					{
						value: 16,
						label: '外地申请'
					},
					{
						value: 17,
						label: '重复申请'
					},
					{
						value: 18,
						label: '短信申请'
					}
				],
				rateList: [{
						value: 0,
						label: '0星'
					},
					{
						value: 1,
						label: '1星'
					},
					{
						value: 2,
						label: '2星'
					},
					{
						value: 3,
						label: '2星+'
					},
					{
						value: 4,
						label: '3星'
					},
					{
						value: 5,
						label: '4星'
					},
				],
				followList: [],
			}
		},
		methods: {
			...mapActions([
				'handleLogOut',
			]),
			async loadData() {
				let that = this;
				if (that.id != 0) {
					let data = {
						token: that.token,
						id: that.id
					};
					let res = await getClientRecord(that, data);
					if (res.code == 1) {
						that.client = res.data.item;
						that.follow = res.data.follow;
						that.followList = res.data.followList;
						that.client.new_phone = that.client.phone.substring(0, 3) + '****' + that.client.phone
							.substring(7, 11)
					}
				}
				that.addContractShow = false;
			},
			invateDayChange(e) {
				this.invateDoor.invate_day = e;
			},
			clickPhoneShow() {
				let that = this;
				if (this.phoneShow == true) {
					this.phoneShow = false;
				} else {
					this.phoneShow = true;
				}
				this.throttle(async function() {
					let data = {
						token: that.token,
						client_id: that.id
					};
					let res = await lookPhone(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
					}
				}, 500)

			},
			saveClientStatus() {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						data: that.client
					};
					data.data.firm = that.firm;
					let res = await saveClient(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
					}
				}, 500)
				if (that.client.status == 7) {
					this.addContractShow = true;
				}
			},
			saveClient() {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						data: that.client
					};
					data.data.firm = that.firm;
					let res = await saveClient(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.loadData();
						that.$emit('reloadData');
					}
				}, 500)
			},
			addClientTag(e) {
				let that = this;
				let id = parseInt(e.currentTarget.dataset.key) + 1;
				this.throttle(async function() {
					let data = {
						token: that.token,
						client_id: that.client.id,
						tag: id
					};
					let res = await addClientTag(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.tagPoptip = false;
						that.$emit('reloadData');
					}
				}, 500)
			},
			addContactTag(e) {
				let that = this;
				let id = parseInt(e.currentTarget.dataset.key) + 1;
				this.throttle(async function() {
					let data = {
						token: that.token,
						client_id: that.client.id,
						tag: id
					};
					let res = await addContactTag(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.$emit('reloadData');
					}
				}, 500)
			},
			addRemark(e) {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						client_id: that.client.id,
						remark: that.remarkValue
					};
					let res = await addRemark(that, data);
					if (res.code == 1) {
						that.remarkValue = '';
						that.$Message.success(res.msg);
						that.$emit('reloadData');
					}
				}, 500)
			},
			saveFollow(e) {
				let that = this;
				let type = e.currentTarget.dataset.type;
				this.throttle(async function() {
					let data = {
						token: that.token,
						client_id: that.client.id,
						data: that.follow,
						type: type
					};
					let res = await saveFollow(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.loadData();
					}
				}, 500)
			},
			handleClose(index) {
				this.tab_list[index].show = false
			},
			callMobile(){
				let that = this;
				let phone = that.client.phone;
				this.$Modal.confirm({
					title: '确认要拨打电话吗？',
					onOk: async () => {
						let res = await sendOrderNotice(that, {
							token: that.token,
							phone: phone
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.loadData();
							that.$emit('reloadData');
						}
					}
				})
			},
			addPool() {
				let that = this;
				let id = that.client.id;
				this.$Modal.confirm({
					title: '确认加入公共池吗？',
					onOk: async () => {
						let res = await addPool(that, {
							token: that.token,
							id: id
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.loadData();
							that.$emit('reloadData');
						}
					}
				})
			},
			async lock() {
				let that = this;
				let id = that.client.id;
				let res = await lock(that, {
					token: that.token,
					id: id
				});
				if (res.code == 1) {
					that.$Message.success(res.msg);
					that.loadData();
				}
			},
			eraseFollow(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.$Modal.confirm({
					title: '确认撤销吗？',
					onOk: async () => {
						let res = await eraseFollow(that, {
							token: that.token,
							id: id
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.loadData();
						}
					}
				})
			},
			async addEmergency(e) {
				let that = this;
				let val = e.currentTarget.dataset.val;
				let res = await addEmergencyTag(that, {
					token: that.token,
					id: that.client.id,
					val: val
				});
				if (res.code == 1) {
					that.$Message.success(res.msg);
					that.$emit('reloadData');
				}
			},
			async changeViewUpTime(e) {
				let res = await getTimeLater(this, {
					token: this.token,
					type: e
				});
				if (res.code == 1) {
					this.follow.door_time_date = res.data.date;
					this.follow.door_time_hour = res.data.time;
				}
			},
			async changeFollowUpTime(e) {
				let res = await getTimeLater(this, {
					token: this.token,
					type: e
				});
				if (res.code == 1) {
					this.follow.follow_time_date = res.data.date;
					this.follow.follow_time_hour = res.data.time;
				}
			},
			beforeOne() {
				let that = this;
				this.$nextTick(() => {
					that.$emit('beforeOne');
				})
			},
			nextOne() {
				let that = this;
				this.$nextTick(() => {
					that.$emit('nextOne');
				})
			},
			changeMenu(name) {

				if (name == 'invate_door') {
					this.invateDoorModal = true

				} else if (name == 'invate_introduce') {
					//设置后台请求地址
					var name = "严松云";
					var address = "南丰创荟";
					const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro
					window.open(baseUrl+'/app/task/invate_door?name='+name+'&address='+address);

				} 
			},
			saveInvateDoor() {
				let that = this;
				var invateDoor = that.invateDoor
				this.$Modal.confirm({
					title: '确认生成邀约上门名片吗？',
					onOk: async () => {
						const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro
						window.open(baseUrl+'/app/task/invate_door?invate_name='+invateDoor.invate_name+'&invate_money='+invateDoor.invate_money+'&invate_day='+invateDoor.invate_day+'&invate_address='+invateDoor.invate_address+'&invate_data='+invateDoor.invate_data);
					}
				})
			},

		},
	}
</script>

<style scoped lang="less">
	.cur_btn {
		span {
			cursor: pointer;
		}
	}

	.img_font {
		font-size: 20px;
	}

	.margin_bottom_css {
		margin-bottom: 5px;
	}

	.tabs_css {
		display: flex;
		flex-wrap: wrap;
	}

	.black_css {
		color: #FFFFFF;
		background-color: #000000;
	}

	.violet_css {
		color: #FFFFFF;
		background-color: #9801FE;
	}

	.green_css {
		color: #FFFFFF;
		background-color: #8FC31F;
	}

	.yellow_css {
		color: #FFFFFF;
		background-color: #d6be32;
	}

	.grey_css {
		color: #FFFFFF;
		background-color: #BFBFBF;
	}

	.orange_css {
		color: #FFFFFF;
		background-color: #EB6100;
	}

	.red_css {
		color: #FFFFFF;
		background-color: #E60012;
	}

	.blue_css {
		color: #FFFFFF;
		background-color: #21A0FF;
	}

	.aaa_css {
		color: #FFFFFF;
		background-color: #E968A1;
	}

	.bbb_css {
		color: #FFFFFF;
		background-color: #FED600;
	}

	.ccc_css {
		color: #FFFFFF;
		background-color: #FF5E5A;
	}

	.ddd_css {
		color: #FFFFFF;
		background-color: #843900;
	}

	.eee_css {
		color: #FFFFFF;
		background-color: #181D4B;
	}

	.fff_css {
		color: #FFFFFF;
		background-color: #007D65;
	}

	.ggg_css {
		color: #FFFFFF;
		background-color: #1D953F;
	}

	.hhh_css {
		color: #FFFFFF;
		background-color: #CA8687;
	}

	.iii_css {
		color: #FFFFFF;
		background-color: #596032;
	}

	.jjj_css {
		color: #FFFFFF;
		background-color: #F36C21;
	}

	.jiesuo_img_font {
		font-size: 30px;
		height: 20px !important;
		line-height: 20px;
		vertical-align: middle;
	}

	.follow_text {
		vertical-align: middle;
		display: inline-block;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		text-align: center;
		width: 160px;
	}

	.flex_align {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.emergency {
		padding: 0 5px;
		border-radius: 3px;
	}

	.white_bg {
		background: white;
		padding: 20px;
		border-radius: 5px;
	}

	.add_record_header {
		font-size: 16px;
		font-weight: bold;
		color: #2A8BF6;
	}

	.before_next_area {
		width: 160px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.plus_add {
		width: 25px;
		height: 25px;
		background-color: #21A0FF;
		color: #FFFFFF;
		border-radius: 50%;
		text-align: center;
		line-height: 25px;
	}
</style>
